import React, { CSSProperties, FunctionComponent } from "react";

// Flamingo (Impact X / NEO theme primary colour) - kept as literal hex here (rather than pulling
// in the $flamingo SCSS variable) because this exact style object is also serialised into a raw
// HTML string for SurveyJS question titles (see sensibleDefaultBadgeHtml below), which can't reach
// into SCSS variables at all.
const FLAMINGO = "#C24E62";
const FLAMINGO_TINT_BACKGROUND = "rgba(194, 78, 98, 0.12)";

// `verticalAlign: "middle"` centres the badge against adjacent plain text (e.g. inside the
// SurveyJS question titles below, which are plain strings with no flex wrapper available). Where
// the caller *does* control the surrounding markup (e.g. circle-ci-info.tsx), prefer wrapping this
// badge and its label in a `display: inline-flex; align-items: center;` container instead - the
// same technique neo-api-ui's `.api-detail-status` uses to centre the "Healthy" pill against the
// API name - since flex alignment is more robust than vertical-align across fonts/line-heights.
export const sensibleDefaultBadgeStyle: CSSProperties = {
  display: "inline-block",
  verticalAlign: "middle",
  backgroundColor: FLAMINGO_TINT_BACKGROUND,
  color: FLAMINGO,
  borderRadius: 4,
  fontSize: "0.60em",
  fontWeight: 600,
  marginLeft: 6,
  marginRight: 6,
  padding: "4px 6px",
};

// Same visual treatment as <SensibleDefaultBadge />, but as a raw HTML string - for embedding inside
// SurveyJS question `title`s, which are plain strings rendered through the survey's markdown
// pipeline (see onTextMarkdown in common/components/forms/index.tsx) rather than JSX.
export const sensibleDefaultBadgeHtml
  = "<span style=\"display:inline-block;vertical-align:middle;background-color:rgba(194, 78, 98, 0.12);color:#C24E62;"
  + "border-radius:4px;font-size:0.60em;font-weight:600;margin-left:6px;margin-right:6px;padding:4px 6px;\">Sensible Default</span>";

const SensibleDefaultBadge: FunctionComponent = () => (
  <span style={sensibleDefaultBadgeStyle}>Sensible Default</span>
);

export default SensibleDefaultBadge;
